var _path, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgGroup2137 = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 45,
    viewBox: "0 0 31 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.4412 15.2206C30.4412 23.6267 19.1912 45 15.2206 45C11.25 45 0 23.6267 0 15.2206C0 6.81449 6.81449 0 15.2206 0C23.6267 0 30.4412 6.81449 30.4412 15.2206Z",
    fill: "#D55A5A"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.2204,
    cy: 15.2207,
    r: 9.92647,
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGroup2137);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Group 2137.03c0ebd0681d863334b9e3e73ade5a0c.svg";